import { TextKey } from '@mews-distributor/common';

const countryCodeCheckoutStatements: Record<string, Mews.TextKey[]> = {
    CZ: [TextKey.LegalStatementOrderObligingToPay],
};

export const getCountryCodeCheckoutStatements = (countryCode: string): Mews.TextKey[] => {
    if (countryCodeCheckoutStatements?.[countryCode] == null) {
        return [];
    }

    return countryCodeCheckoutStatements[countryCode];
};
